import { Result } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

const Error = props => {
  const { error } = props;
  return <Result status="error" title="Error Creating File!" subTitle={error} />;
};

Error.propTypes = {
  error: PropTypes.string.isRequired,
};

export default Error;
